<template>
  <li class="campaign-list-item">
    <div class="campaign-heading flex flex-row" :class="campaign.bookings_count ? 'cursor-pointer' : ''" @click="toggleBookings">
      <div class="campaign-heading__highlight"><i class="fa fa-clone fa-lg"></i></div>
      <div class="campaign-heading__main">
        <div>
          Campaign | {{ campaign.name }}
        </div>
        <router-link class="campaign-heading__main--link" :to="{ name: 'campaign.edit', params: { id: campaign.id }}">
          View Campaign <i class="fa fa-chevron-right"></i>
        </router-link>
      </div>
    </div>
    <div class="campaign-body">
      <div class="flex flex-row justify-between margin-b-5">
        <div class="w-3/4">
          <p class="campaign-body__description"><span v-if="!campaign.bookings_count" class="draft-label">Draft</span>{{ campaign.stripped_description }}</p>
          <i class="fa fa-calendar margin-r-1"></i> Start Date: {{ campaign.start_date | date }} <span v-if="campaign.end_date">| End Date: {{ campaign.end_date | date }}</span>
        </div>
        <div class="flex flex-col items-end w-1/4">
          <div @click="toggleBookings"
               class="toggle-button"
               :class="!campaign.bookings_count ? 'toggle-button--disabled' : ''">
            <i class="fa" :class="bookings_expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </div>
          Requests: {{ campaign.bookings_count }}
        </div>
      </div>
      <ul v-if="bookings_expanded && campaign.bookings_count" style="padding-left: 0;">
        <campaign-list-item-booking-list-item v-for="booking in campaign.bookings" :booking="booking" :key="booking.id" />
      </ul>
      <div class="flex justify-center spacer-t-3 underline" v-if="bookings_expanded && campaign.bookings_count > 5">
        <router-link :to="{ name: 'campaign.edit', params: { id: campaign.id }}">
          <span>Show {{ campaign.bookings_count - 5 }} more</span>
        </router-link>
      </div>
      <router-link class="create-request" :to="{ name: 'requests.create', query: { campaign_id: campaign.id } }" v-if="!campaign.bookings_count">
        <i class="fa fa-plus"></i>&nbsp;Create request
      </router-link>
    </div>
  </li>
</template>

<script>
import CampaignListItemBookingListItem from './CampaignListItemBookingListItem'
export default {
  components: {CampaignListItemBookingListItem},
  props: {
    campaign: {
      type: Object
    }
  },

  methods: {
    toggleBookings () {
      if (this.campaign.bookings_count) {
        this.bookings_expanded = !this.bookings_expanded
      }
    }
  },

  data () {
    return {
      bookings_expanded: false
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-list-item {
  margin-top: 25px;
  margin-bottom: 25px;
}
.campaign-heading {
  color: white;
  background-color: var(--brand-info);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  &__highlight {
    background-color: var(--brand-info-dark);
    padding: 10px;
    min-width: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__main {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    &--link {
      font-size: 12px;
      color: white;
      margin-right: 15px;
    }
  }
}
.create-request {
  border: 1px dashed #e3e3e3;
  color: #52525B;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  &:hover {
    color: #6f6f6f;
    border-color: #d0d0d0;
  }
}
.toggle-button {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #e3e3e3;
  color: black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  &--disabled {
    color: #e3e3e3;
    background-color: #f9f9f9;
    cursor: not-allowed;
  }
}
.campaign-body {
  background: white;
  border-left: #e3e3e3 8px solid;
  padding: 25px 20px;
  color: #52525B;
  &__description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .draft-label {
      background-color: var(--brand-primary);
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
      color: white;
      padding: 1px 4px;
      margin-right: 8px;
    }
  }
}
</style>
